import React, { useContext } from "react";
import SliderContext from "./context";

export function Dots() {
  const { activeIndex, setActive, count } = useContext(SliderContext);

  return (
    <ul className="slick-dots-presentation" role="tablist">
      {Array.from({ length: count }).map((_, index) => (
        <li
          className={activeIndex === index ? "slick-active" : ""}
          role="presentation"
          onClick={(e) => setActive(index)}
        >
          <button
            type="button"
            role="tab"
            id={`slick-slide-control${index}`}
            aria-controls={`slick-slide-control${index}`}
            aria-label={`${index + 1} of ${count}`}
            tabindex="-1"
          >
            {index + 1}
          </button>
        </li>
      ))}
    </ul>
  );
}
